import script from "./RegulationMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./RegulationMobile.vue?vue&type=script&setup=true&lang=js"

import "./RegulationMobile.vue?vue&type=style&index=0&id=fe581ce4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe581ce4"]])

export default __exports__